<template>
  <div class="stickyButton">
    <a :href="link" target="_blank">
      <img v-if="visual" :src="visual?.src" :alt="visual?.alt" />
      <span v-if="text">{{ text }}</span>
    </a>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  link: string
  visual?: {
    src: string
    alt: string
  }
  text?: string
}>()
</script>

<style scoped lang="scss">
.stickyButton {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  background-color: $blue;
  border-radius: 50%;
  aspect-ratio: 1;
  z-index: 2;

  @include mediaMax($bp-sm) {
    width: 9rem;
  }

  a,
  a:visited {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $white;
    width: 100%;
    height: 100%;
    text-decoration: none;
    font-size: 1.5rem;
    padding: 2rem;
    box-sizing: border-box;

    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
